export default __webpack_public_path__ + "static/media/undraw_time_management_30iu.8b835e3b.svg";